import React, { useState } from 'react';
import { gearData } from '../data/gearData';

const Gear = ({ hideHeader = false, hideBackgroundImages = false, compactMode = false }) => {
  const [openCategories, setOpenCategories] = useState({});

  const toggleCategory = (categoryIndex) => {
    setOpenCategories(prev => ({
      ...prev,
      [categoryIndex]: !prev[categoryIndex]
    }));
  };

  return (
    <section id="wrapper">
      {hideBackgroundImages && (
        <style>
          {`
            .wrapper.spotlight.style2:before,
            .wrapper.spotlight.style2:after {
              background-image: none !important;
            }
          `}
        </style>
      )}
      {compactMode && (
        <style>
          {`
            .wrapper.spotlight.style2 {
              padding-top: 0 !important;
              padding-bottom: 0 !important;
              margin-top: 0 !important;
              margin-bottom: 0 !important;
            }
            .wrapper.spotlight.style2 .inner {
              padding: 10px !important;
            }
          `}
        </style>
      )}
      <section className="wrapper spotlight style2" style={{ backgroundColor: "#65656C" }}>
        <div className="inner">
          <div className="content">
            <section id="recommended-gear">
              {!hideHeader && (
                <>
                  <h2 className="major">{gearData.title}</h2>
                  <p style={{ fontSize: "1.05em", marginBottom: "10px" }}>
                    The right gear doesn't just make training more comfortable—it makes you a better, safer shooter.
                  </p>
                  <p style={{ fontSize: "0.95em", marginBottom: "15px", opacity: "0.9" }}>
                    Every item on this list has been personally tested and proven in real training sessions. We only recommend gear we trust and use ourselves.
                  </p>
                </>
              )}              
              {gearData.categories.map((category, categoryIndex) => (
                <div key={categoryIndex} style={{ marginBottom: "20px" }}>
                  <button
                    style={{
                      width: "100%",
                      textAlign: "left",
                      background: "rgba(255, 255, 255, 0.15)",
                      border: "1px solid rgba(255, 255, 255, 0.3)",
                      borderRadius: "6px",
                      padding: "15px 20px",
                      cursor: "pointer",
                      fontSize: "1em",
                      fontWeight: "bold",
                      color: "#fff",
                      marginBottom: "0",
                      transition: "all 0.3s ease",
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "center",
                      outline: "none",
                      userSelect: "none",
                      WebkitUserSelect: "none",
                      MozUserSelect: "none",
                      msUserSelect: "none"
                    }}
                    onMouseEnter={(e) => {
                      e.currentTarget.style.background = "rgba(255, 255, 255, 0.2)";
                    }}
                    onMouseLeave={(e) => {
                      e.currentTarget.style.background = "rgba(255, 255, 255, 0.15)";
                    }}
                    onFocus={(e) => {
                      e.currentTarget.style.background = "rgba(255, 255, 255, 0.15)";
                      e.currentTarget.style.outline = "none";
                    }}
                    onBlur={(e) => {
                      e.currentTarget.style.background = "rgba(255, 255, 255, 0.15)";
                    }}
                    onMouseDown={(e) => {
                      e.currentTarget.style.background = "rgba(255, 255, 255, 0.15)";
                    }}
                    onMouseUp={(e) => {
                      e.currentTarget.style.background = "rgba(255, 255, 255, 0.2)";
                    }}
                    onClick={(e) => {
                      e.preventDefault();
                      e.stopPropagation();
                      toggleCategory(categoryIndex);
                    }}
                  >
                    <span style={{ 
                      pointerEvents: "none",
                      userSelect: "none",
                      WebkitUserSelect: "none"
                    }}>{category.category}</span>
                    <span style={{ 
                      fontSize: "0.8em",
                      transition: "transform 0.3s ease",
                      transform: openCategories[categoryIndex] ? "rotate(180deg)" : "rotate(0deg)",
                      pointerEvents: "none",
                      userSelect: "none",
                      WebkitUserSelect: "none"
                    }}>
                      ▼
                    </span>
                  </button>
                  
                  {openCategories[categoryIndex] && (
                    <div 
                      style={{
                        display: "grid",
                        gridTemplateColumns: "repeat(auto-fit, minmax(300px, 1fr))",
                        gap: "15px",
                        marginTop: "15px",
                        padding: "15px",
                        backgroundColor: "rgba(0, 0, 0, 0.2)",
                        borderRadius: "6px"
                      }}
                    >
                      {category.items.map((item, itemIndex) => (
                        <div 
                          key={itemIndex} 
                          style={{ 
                            padding: "15px", 
                            backgroundColor: "rgba(255, 255, 255, 0.1)",
                            borderRadius: "6px",
                            border: "1px solid rgba(255, 255, 255, 0.2)"
                          }}
                        >
                          <h4 style={{ fontSize: "1em", marginBottom: "8px", lineHeight: "1.3" }}>
                            <a 
                              href={item.affiliate_link} 
                              target="_blank" 
                              rel="noopener noreferrer"
                              style={{ 
                                color: "#FF5722", 
                                textDecoration: "none",
                                outline: "none",
                                WebkitTapHighlightColor: "transparent"
                              }}
                              onFocus={(e) => {
                                e.target.style.outline = "none";
                                e.target.style.backgroundColor = "transparent";
                              }}
                              onMouseDown={(e) => {
                                e.target.style.backgroundColor = "transparent";
                              }}
                            >
                              {item.name}
                            </a>
                            <span style={{ 
                              display: "block",
                              marginTop: "5px",
                              fontSize: "0.85em", 
                              opacity: "0.9", 
                              fontWeight: "normal",
                              color: "#fff"
                            }}>
                              {item.price_range}
                            </span>
                          </h4>
                          <p style={{ 
                            margin: "0", 
                            opacity: "0.9", 
                            lineHeight: "1.5",
                            fontSize: "0.9em"
                          }}>
                            {item.description}
                          </p>
                        </div>
                      ))}
                    </div>
                  )}
                </div>
              ))}
              
              <p style={{
                marginTop: "30px",
                fontSize: "0.75em",
                opacity: "0.7",
                fontStyle: "italic",
                textAlign: "center",
                color: "#fff"
              }}>
                As an Amazon Associate, Range Drills earns from qualifying purchases.
                We only recommend products we believe will enhance your training experience and have been personally tested and used by us.
              </p>
            </section>
          </div>
        </div>
      </section>
    </section>
  );
};

export default Gear;
